/**
 * Accepts a bare embed URL or a full <iframe ... src="..."> snippet from env.
 * Returns the dashboard URL only, or undefined if none could be derived.
 */
export const HARPWOOD_MONITORING_DASHBOARD_URL =
  'https://app.powerbi.com/view?r=eyJrIjoiZDUxODM4OWYtODE0NC00Yjc4LWFjYjUtYmM4M2M2MTM2MDNmIiwidCI6ImUzNmQ3NWZhLWU4NjItNDAyMC05MzllLTU0YjFiNDQ2NGFlMSJ9';

export function parseMonitoringDashboardUrl(raw: string | undefined): string | undefined {
  if (raw == null) return undefined;
  const trimmed = raw.trim();
  if (!trimmed) return undefined;

  const srcMatch = trimmed.match(/\bsrc\s*=\s*["']([^"']+)["']/i);
  if (srcMatch?.[1]) {
    const fromIframe = srcMatch[1].trim();
    if (fromIframe) return fromIframe;
  }

  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }

  return undefined;
}

export function getMonitoringDashboardUrl(): string {
  return (
    parseMonitoringDashboardUrl(process.env.REACT_APP_MONITORING_DASHBOARD_URL) ??
    HARPWOOD_MONITORING_DASHBOARD_URL
  );
}
